export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '内保流水单号',
            minWidth: 200,
            fixed: 'left',
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100,
        },
        // {
        //     prop: 'status',
        //     label: '状态',
        //     minWidth: 100,
        //     render: ({ status }) => {
        //         return (this.$emun.status.find(item => item.value === status)).label || '-'
        //     }
        // },
		{
		    prop: 'payChannel',
		    label: '支付渠道',
		    minWidth: 200,
		},
        {
            prop: 'beginTime',
            label: '内保起期',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'endTime',
            label: '内保止期',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'carType',
            label: '车型',
            minWidth: 200,
        },
        {
            prop: 'accidentCount',
            label: '出险次数',
            minWidth: 100,
        },

        {
            prop: 'contractFee',
            label: '标准内保费',
            minWidth: 100,
        },
        {
            prop: 'cusRebate',
            label: '整单折扣',
            minWidth: 100,
        },
        {
            prop: 'cusFee',
            label: '应交内保费',
            minWidth: 100,
        },
        {
            prop: 'customerRebate',
            label: '客户折扣',
            minWidth: 100,
        },
        {
            prop: 'customerFee',
            label: '客户内保费',
            minWidth: 100,
        },
        {
            prop: 'cashRebate',
            label: '费用政策(%)',
            minWidth: 150,
        },
        {
            prop: 'netFee',
            label: '净费',
            minWidth: 150,
        },
        {
            prop: 'realInFee',
            label: '实收金额(元)',
            minWidth: 100,
        },
        {
            prop: 'orgName',
            label: '出单机构',
        },
        {
            prop: 'saleName',
            label: '业务员',
            minWidth: 100,
        },
        {
            prop: 'creatorName',
            label: '制单员',
            minWidth: 100,
        },
        {
            prop: 'HandlerName',
            label: '经办人',
            sortable: true,
            minWidth: 100,
        },
        {
            prop: 'auditName',
            label: '审核人',
            sortable: true,
            minWidth: 100,
        },
        {
            prop: 'create_time',
            label: '提交时间',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'auditTime',
            label: '审核时间',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'payTime',
            label: '交费时间',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'handle',
            label: '操作',
            minWidth: 100,
            fixed: 'right'
        }
    ]
}

export default {}